import { IComboBox, IComboBoxOption } from "@fluentui/react";
import { Ifilter } from "../../../Interfaces/filter";
import { useEffect, useRef, useState } from "react";
import { AxiosResponse } from "axios";

interface IUseComboProps<F extends Ifilter> {
    isOpen: boolean;
    filter: F;
    setFilter: (filter: F) => void;
    fetchData: (filter: F, controller: AbortController) => Promise<AxiosResponse<any, any>>;
}
export const UseComboGeneric= <F extends Ifilter>(props: IUseComboProps<F>) =>{
    const controllerRef = useRef<AbortController>(new AbortController());
    const [dataCombo, setDataCombo] = useState<IComboBoxOption[]>([]);
    const comboBoxRef = useRef<IComboBox>(null);
    const onClickCombo = () => comboBoxRef.current?.focus(true);
    const onChangeGeneric = (value: string) => {
        props.setFilter({ ...props.filter, search: value });
    };
    const onKeyUpSearch = (event: React.KeyboardEvent<IComboBox>) => {
        if (event.code === 'Escape') {
            comboBoxRef.current?.focus(false);
            props.setFilter({
                ...props.filter,
                skip: 0,
                take: 20,
                search: '',
            });
        } else {
            const { value } = event.target as HTMLInputElement;
            props.setFilter({ ...props.filter, search: value });
        }
    };
    const listarCombo = () => {
        controllerRef.current.abort();
        const newController = new AbortController();
        controllerRef.current = newController;
        props.fetchData(props.filter, newController).then((res) => {
            setDataCombo(res.data);
        });
    };
    useEffect(() => {
        if (props.isOpen) {
            listarCombo();
        }
    }, [props.isOpen]);
    useEffect(() => {
        listarCombo();
    }, [props.filter.search]);
    return {
        dataCombo,
        onClickCombo,
        onKeyUpSearch,
        comboBoxRef,
        onChangeGeneric,
    }
}